import React from "react";

// Tela vazia ou de erro: diz o que aconteceu e oferece o próximo passo.
const EstadoVazio = ({ icone, titulo, texto, acao }) => (
  <div className="gm-estado-vazio" role="status">
    {icone && <div className="gm-estado-vazio__icone" aria-hidden="true">{icone}</div>}
    {titulo && <p className="gm-estado-vazio__titulo">{titulo}</p>}
    {texto && <p className="gm-estado-vazio__texto">{texto}</p>}
    {acao && <div className="gm-estado-vazio__acao">{acao}</div>}
  </div>
);

export default EstadoVazio;
